export default __webpack_public_path__ + "static/header-types-dark-07d058c35aee998ceae8ff6eb344d2fe382920d9e7f62c41a428f410a2eac255.png";